import EVENTS from '@shared/events';
import { BaseController } from '@shared/basecontroller.controller';
import { BitcoinWithdrawalForm } from './bitcoin-withdrawal-form.model';

class BitcoinWithdrawalFormController extends BaseController {
  constructor(AppService, WithdrawalStore, FormService, PaymentOptionApiService, TransactionApiService, $timeout, $document) {
    'ngInject';

    super(AppService);

    this.WithdrawalStore = WithdrawalStore;
    this.FormService = FormService;
    this.PaymentOptionApiService = PaymentOptionApiService;
    this.TransactionApiService = TransactionApiService;
    this.$timeout = $timeout;
    this.$document = $document;

    this.bitcoinRate = null;
    this.bitcoinTransaction == null;
  }

  $onInit() {
    this.userCurrency$ = this.WithdrawalStore.getCurrency();
    this.session = this.getSession();

    this.form = new BitcoinWithdrawalForm(this.details.customerProducts, this.details.paymentOptions);
    this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;
    this.form.receiverAddress = this.selectedPaymentOption.extras.accountId;
    this.form.paymentOption = this.selectedPaymentOption.id;
    this.form.paymentOptionType = this.selectedPaymentOption.type;
    this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('withdrawal');
    this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('withdrawal');
    this.enableSidebar();

    this.addListener(EVENTS.BTC_EXCHANGE_RATE, event => {
      if (event.bitcoinRate.type === 'withdrawal') {
        this.form.bitcoinRate = event.bitcoinRate;
        this.bitcoinRate = event.bitcoinRate;
        this.blinkExchangeRate();
        this.onWithdrawalBtcInputChanged();
      }
    });

    // Display the form when all the promises has been completed.
    Promise.all([this.getBitcoinRate()]).then((values) => {
      this.form.props.isReady = true;
    });
  }

  // This would handle the initial display when loading the Bitcoin Form.
  getBitcoinRate() {
    return this.PaymentOptionApiService.getBitcoinWithdrawalAdjustment().then(bitcoinRate => {
      this.bitcoinRate = bitcoinRate;
      // TODO: Do not set bitcoinRate on form.
      this.form.bitcoinRate = bitcoinRate;
    });
  }

  checkForActiveBitcoinTransaction() {
    return this.TransactionApiService.checkForActiveBitcoinTransaction().then(bitcoinTransaction => {
      this.bitcoinTransaction = bitcoinTransaction;
    });
  }

  enableSidebar() {
    this.$timeout(() => {
      $(".gateway-sidebar-wrap .fa-receipt").click(function(e){
        e.preventDefault();
        $(".gateway-sidebar-wrap").toggleClass('active');
      });
    }, 500);
  }

  onWithdrawalBtcInputChanged() {
    let adjustedRate = this.form.getBtcAdjustedRate(this.bitcoinRate);
    let btcAdjustedDisplay = document.getElementById('btc-adjusted-value');
    btcAdjustedDisplay.innerHTML = adjustedRate;

    this.form.computeAmountConversion(adjustedRate);
  }

  onWithdawalAmountInputChanged() {
    let adjustedRate = this.form.getBtcAdjustedRateFromTotalAmount(this.bitcoinRate);
    let btcAdjustedDisplay = document.getElementById('btc-adjusted-value');
    btcAdjustedDisplay.innerHTML = adjustedRate;
  
    this.form.computeBitcoinConversion(adjustedRate);
  }

  submit() {
    this.FormService.isSubmitting.next(true);
      this.WithdrawalStore.withdraw(this.form.toPayload(this.bitcoinRate))
      .then(() => this.handleSuccessfulSubmission())
      .catch((errors) => {
        this.form.error.setFormErrors(errors);
        this.FormService.isSubmitting.next(false);
      })
    ;
  }

  handleSuccessfulSubmission() {
    this.FormService.isSubmitting.next(false);
    this.form.clearError();
    this.form.props.readOnly = true;
    this.onSuccessfulSubmission({form: this.form, viewDetails: this.paymentOptionsViewDetails});
  }

  resetForm() {
    this.form.reset();
  }

  removeSubTransaction(subTransaction, index) {
    this.form.removeSubTransaction(subTransaction, index);
  }

  formatAmount(subTransaction) {
    return subTransaction.amount = parseFloat(subTransaction.amount);
  }

  formatBTC(subTransaction) {
    return subTransaction.btc = parseFloat(subTransaction.btc);
  }

  blinkExchangeRate() {
    const exchangeRate = document.getElementsByClassName('exchange-rate')[0];
    exchangeRate.classList.add('blinking');

    let seconds = 0;

    this.blinkInterval = setInterval(() => {
      seconds += 1000;

      if (seconds === 2000) {
        exchangeRate.classList.remove('blinking');
        clearInterval(this.blinkInterval);
      }
    }, 2000);
  }

  get displayDeleteButton() {
    return this.form.subTransactions.length > 1;
  }
}

export default BitcoinWithdrawalFormController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/component/form/bitcoin/bitcoin-withdrawal-form.controller.js